import axios, { AxiosError, AxiosResponse, Method } from 'axios'

/**
 * Copyright 2022-04-26 por Alfonso Moya Ecomsur Holding S.A ©
 * Detalle: Se agrega enpoint InboundAdjustWorkOrder
 */

const URL = import.meta.env.VITE_API_URL
const SUFFIX = import.meta.env.VITE_WMS_SUF
const URI = SUFFIX ? `${URL}/${SUFFIX}` : `${URL}`

const URLEXTERNALAUDIT = import.meta.env.VITE_API_URL_EXTERNAL_AUDIT
const KEYEXTERNALAUDIT = import.meta.env.VITE_API_KEY_EXTERNAL_AUDIT

// URL API DEFINIDAS EN ENVIROMENT FILE
const StockKeepingUnitApi = `${URI}/api/stockkeepingunit`
const UserApi = `${URI}/api/user`
const UserAdminApi = `${URI}/api/userAdmin`
const SkillApi = `${URI}/api/skill`
const TipoPerfilApi = `${URI}/api/tipoPerfil`
const WareHouseApi = `${URI}/api/warehouse`
const ZoneApi = `${URI}/api/zone`
const SubZoneApi = `${URI}/api/subzone`
const PositionApi = `${URI}/api/position`
const TypepositionApi = `${URI}/api/typeposition`
const OrderApi = `${URI}/api/Order`
const WorkOrderApi = `${URI}/api/WorkOrder`
const PickingRouteApi = `${URI}/api/PickingRoute`
const PickingRouteAdminApi = `${URI}/api/PickingRouteAdmin`
const CourierApi = `${URI}/api/Courier`
const TypeWorkOrderApi = `${URI}/api/TypeWorkOrder`
const PickingRouteValidationApi = `${URI}/api/PickingRouteValidation`
const ProcessApi = `${URI}/api/Process`
const StockApi = `${URI}/api/Stock`
const InventoryIncident = `${URI}/api/InventoryIncident`
const WorkOrderStateApi = `${URI}/api/WorkOrderState`
const WorkOrderDashboardApi = `${URI}/api/WorkOrderDashBoard`
const StockMovementApi = `${URI}/api/StockMovement`
const TypeMovementApi = `${URI}/api/TypeMovement`
const SupplierApi = `${URI}/api/Supplier`
const SupplierOriginApi = `${URI}/api/SupplierOrigin`
const PackingListApi = `${URI}/api/PackingList`
const AsnApi = `${URI}/api/Asn`
const TypeAsnListApi = `${URI}/api/TypeAsnDocument`
const TypeAsnIncomeApi = `${URI}/api/TypeAsnIncome`
const AsnBlogApi = `${URI}/api/AsnBlog`
const PickingRouteDetailsApi = `${URI}/api/PickingRouteDetails`
const AsnStateApi = `${URI}/api/AsnState`
const TypeAsnSource = `${URI}/api/TypeAsnSource`
const AsnDetailApi = `${URI}/api/AsnDetail`
const ConfigurationApi = `${URI}/api/Configuration`
const TypeConfigurationApi = `${URI}/api/TypeConfiguration`
const TypeProcessApi = `${URI}/api/TypeProcess`
const StockKeepingUnitDun = `${URI}/api/StockKeepingUnitDun`
const DispatchOt = `${URI}/api/Dispatch`
const TypeInventoryIncident = `${URI}/api/TypeInventoryIncident`
const InboundApi = `${URI}/api/Inbound`
const InboundAdjust = `${URI}/api/InboundAdjust`
const InboundAdjustWorkOrder = `${URI}/api/InboundAdjustWorkOrder`
const InboundAdjustWorkOrderLpn = `${URI}/api/InboundAdjustWorkOrder/Lpn`
const InboundAdjustSku = `${URI}/api/InboundAdjustSku`
const DeclareExcess = `${URI}/api/InboundAdjustSku/DeclareExcess`
const InboundHistoryApi = `${URI}/api/InboundHistory`
const RelocateApi = `${URI}/api/RelocateSku`
const InboundDeclareErrorApi = `${URI}/api/InboundDeclareError`
const CarrierApi = `${URI}/api/Carrier`
const InboundSearchApi = `${URI}/api/InboundSearch`
const PickingDashboard = `${URI}/api/PickingDashboard`
const WorkOrderStatusApi = `${URI}/api/WorkOrderStatus`
const PickingRouteStatusApi = `${URI}/api/PickingRouteStatus`
const WorkOrderTagApi = `${URI}/api/WorkOrderTag`
const ProductOriginApi = `${URI}/api/ProductOrigin`
const OrderLabelApi = `${URI}/api/OrderLabel`
const OrderOriginApi = `${URI}/api/OrderOrigin`
const AsnReturnApi = `${URI}/api/AsnReturn`
const InboundAdjustSkuGetAsnReturnSku = `${URI}/api/InboundAdjustSku/GetAsnReturnSku`
const InboundAdjustReturnRelease = `${URI}/api/AsnReturn/Release`
const PositionAlert = `${URI}/api/PositionAlert`
const WebhookApi = `${URI}/api/WebhookSubscribers`
const WebhookEventApi = `${URI}/api/WebhookEvents`
const WorkOrderOutboundApi = `${URI}/api/WorkOrderOutbound`
const WorkOrderBlog = `${URI}/api/WorkOrderBlog`
const PickingRouteSummaryApi = `${URI}/api/PickingRoute/GetSummary`
const AsnReceptionApi = `${URI}/api/AsnReception`
const AsnReceptionLpnApi = `${URI}/api/AsnReceptionLpn`
const StockKeepingUnitImageApi = `${URI}/api/StockKeepingUnitImage`

const AsnDetailBloqUserLpn = `${URI}/api/AsnDetail/UpdateUserByLpn`
const PositionAlertDetail = `${URI}/api/PositionAlertDetail`
const AsnDetailUpdateLpnState = `${URI}/api/AsnDetail/AsnUpdateStateLpn`
const TypesOrderApi = `${URI}/api/TypeOrder`
const TypesPickingRouteApi = `${URI}/api/TypePickingRoute`
const InventoryCheckApi = `${URI}/api/InventoryCheck`
const InventoryCheckDetailApi = `${URI}/api/InventoryCheckDetail`
const InventoryCheckDetailItemApi = `${URI}/api/InventoryCheckDetailItem`
const InventoryCheckUserApi = `${URI}/api/InventoryCheckUser`
const WorkOrderRecallApi = `${URI}/api/WorkOrderRecall`
const TypeAlertApi = `${URI}/api/TypeAlert`
const FlowApi = `${URI}/api/Flow`
const PreSaleSkuApi = `${URI}/api/PreSaleSku`
const TypePackageApi = `${URI}/api/TypePackage`

const RestockOrderApi = `${URI}/api/RestockOrder`

const TypePriorityApi = `${URI}/api/TypePriority`
const TypeStorageApi = `${URI}/api/TypeStorage`
const TypeOperationApi = `${URI}/api/TypeOperation`

const TypeVasApi = `${URI}/api/TypeVas`
const VasRuleApi = `${URI}/api/VasRule`
const TypeValidationVasApi = `${URI}/api/TypeValidationVas`
const FlowVasApi = `${URI}/api/FlowVas`
const VasRuleDetailApi = `${URI}/api/VasRuleDetail`
const VasRuleSkuApi = `${URI}/api/VasRuleSku`
const VasRuleOrderDetailApi = `${URI}/api/VasRuleOrderDetail`

// Recursos y key para conectar con servicio de logs para
// almacenamiento de comunicación con stock, outbound e inbound externo
const ExternalAuditApi = `${URLEXTERNALAUDIT}/api/ExternalAudit`
const ExternalAuditKey = KEYEXTERNALAUDIT
const PreInboundReason = `${URI}/api/PreInboundReason`
const PreInbound = `${URI}/api/PreInbound`

const StockKeepingUnitAdminApi = `${URI}/api/StockKeepingUnitAdmin`
const SettiingsApi = `${URI}/api/Settings`

axios.defaults.timeout = 30000

export const apiCall = function (
  method: Method | undefined,
  route: string,
  body: unknown | undefined = null
) {
  const onSuccess = function (response: AxiosResponse) {
    return response
  }

  const onError = function (error: AxiosError) {
    if (error.response) {
      return Promise.reject(error.response)
    }
    return Promise.reject({
      data: { message: error.message || 'Error de conexión' }
    })
  }

  return axios({
    method,
    url: route,
    data: body
  })
    .then(onSuccess)
    .catch(onError)
}

export const ApiConfig = {
  StockKeepingUnitApi,
  UserApi,
  UserAdminApi,
  SkillApi,
  TipoPerfilApi,
  WareHouseApi,
  ZoneApi,
  SubZoneApi,
  PositionApi,
  TypepositionApi,
  OrderApi,
  WorkOrderApi,
  PickingRouteApi,
  PickingRouteAdminApi,
  PickingRouteSummaryApi,
  CourierApi,
  TypeWorkOrderApi,
  PickingRouteValidationApi,
  ProcessApi,
  StockApi,
  InventoryIncident,
  WorkOrderStateApi,
  WorkOrderDashboardApi,
  StockMovementApi,
  TypeMovementApi,
  SupplierApi,
  SupplierOriginApi,
  PackingListApi,
  AsnApi,
  TypeAsnListApi,
  TypeAsnIncomeApi,
  AsnBlogApi,
  PickingRouteDetailsApi,
  AsnStateApi,
  TypeAsnSource,
  AsnDetailApi,
  ConfigurationApi,
  TypeConfigurationApi,
  TypeProcessApi,
  StockKeepingUnitDun,
  DispatchOt,
  TypeInventoryIncident,
  InboundApi,
  InboundAdjust,
  InboundAdjustWorkOrder,
  InboundAdjustWorkOrderLpn,
  InboundAdjustSku,
  DeclareExcess,
  InboundHistoryApi,
  InboundDeclareErrorApi,
  PickingDashboard,
  RelocateApi,
  CarrierApi,
  InboundSearchApi,
  WorkOrderStatusApi,
  PickingRouteStatusApi,
  WorkOrderTagApi,
  ProductOriginApi,
  OrderLabelApi,
  OrderOriginApi,
  AsnReturnApi,
  InboundAdjustReturnRelease,
  InboundAdjustSkuGetAsnReturnSku,
  PositionAlert,
  WebhookApi,
  WebhookEventApi,
  WorkOrderOutboundApi,
  WorkOrderBlog,
  AsnReceptionApi,
  AsnReceptionLpnApi,
  AsnDetailBloqUserLpn,
  PositionAlertDetail,
  StockKeepingUnitImageApi,
  AsnDetailUpdateLpnState,
  TypesOrderApi,
  TypesPickingRouteApi,
  ExternalAuditApi,
  ExternalAuditKey,
  WorkOrderRecallApi,
  InventoryCheckApi,
  InventoryCheckUserApi,
  InventoryCheckDetailApi,
  InventoryCheckDetailItemApi,
  RestockOrderApi,
  TypePriorityApi,
  TypeStorageApi,
  TypeAlertApi,
  FlowApi,
  TypeOperationApi,
  PreSaleSkuApi,
  TypePackageApi,
  PreInboundReason,
  PreInbound,
  TypeVasApi,
  VasRuleApi,
  VasRuleDetailApi,
  TypeValidationVasApi,
  FlowVasApi,
  VasRuleSkuApi,
  VasRuleOrderDetailApi,
  StockKeepingUnitAdminApi,
  SettiingsApi
}
